import language from "./languageReducer";
import userSettings from "./userSettingsReducer";

export default {
  language,
  userSettings,
};
